"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const r = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.35 5.76h-2.7v8.53h2.7zM12 18.608a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m0 18.125A8.124 8.124 0 0 1 3.875 12 8.124 8.124 0 0 1 12 3.875 8.123 8.123 0 0 1 20.123 12 8.124 8.124 0 0 1 12 20.125",
        clipRule: "evenodd"
      }
    )
  }
), d = l(r);
export {
  d as Alert,
  d as default
};
